import type { Rule } from '../types'
import { ACCESS_RULES } from './access'
import { HARDENING_RULES } from './hardening'
import { HYGIENE_RULES } from './hygiene'
import { MANAGEMENT_RULES } from './management'
import { POLICY_RULES } from './policy'
import { PROFILE_RULES } from './profiles'
import { VPN_RULES } from './vpn'

/**
 * Every FortiGate check, in the order they are documented on the site.
 *
 * The count is a marketing number as well as a technical one, so it is asserted in
 * `rules.test.ts` — the landing page must never claim more checks than ship.
 */
export const FORTIGATE_RULES: Rule[] = [
  ...MANAGEMENT_RULES,
  ...POLICY_RULES,
  ...HYGIENE_RULES,
  ...HARDENING_RULES,
  ...PROFILE_RULES,
  ...VPN_RULES,
  ...ACCESS_RULES,
]

export {
  ACCESS_RULES,
  HARDENING_RULES,
  HYGIENE_RULES,
  MANAGEMENT_RULES,
  POLICY_RULES,
  PROFILE_RULES,
  VPN_RULES,
}
